import React from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import {
  RootContainer,
  StyledTitle,
  StyledQuestion,
  SupportButton,
  NewTicketButton,
} from './styles';

export function Description() {
  const navigate = useNavigate();

  return (
    <RootContainer>
      <Box sx={{ maxWidth: '500px' }}>
        <StyledTitle>Perguntas Frequentes (FAQ)</StyledTitle>
        <Typography>
          Antes de abrir um novo ticket, verifique se a sua dúvida pode ser
          resolvida aqui. Se precisar de mais ajuda, nossa equipe de suporte
          está à disposição.
        </Typography>
      </Box>
      <Box sx={{ textAlign: 'right' }}>
        <StyledQuestion>Ainda tem dúvidas?</StyledQuestion>
        <SupportButton
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          onClick={() => navigate('/support')}
        >
          Meus Tickets
        </SupportButton>
        <NewTicketButton
          variant="contained"
          onClick={() => navigate('/new-ticket')}
        >
          Abrir novo ticket
        </NewTicketButton>
      </Box>
    </RootContainer>
  );
}
